import { selectablePresence, type PresenceChannel } from './shellPresence';

/**
 * The status channel to the Desktop platform shell (lib/shellPresence.ts): through the preload
 * bridge, the shell's account menu shows Bunker's status and asks for a new one. Null in a browser,
 * in the old tabbed Desktop and with an older preload.
 */
export function desktopPresenceChannel(bridge: Window['bunkerDesktop']): PresenceChannel | null {
  if (!bridge?.platformShell || typeof bridge.reportPresence !== 'function' || typeof bridge.onSetPresence !== 'function') return null;
  const reportPresence = bridge.reportPresence;
  const onSetPresence = bridge.onSetPresence;
  return {
    report: (status, error) => reportPresence(error ? { status, error } : { status }),
    onSet: (cb) => onSetPresence((value) => {
      const status = selectablePresence(value);
      if (status) cb(status);
    }),
    onHosted: (cb) => (typeof bridge.onPresenceHosted === 'function' ? bridge.onPresenceHosted(cb) : () => undefined),
  };
}
